













import Vue from 'vue';
import { Users, InviteUserBtn, ListElement } from 'mycorems-app-accounts';

export default Vue.extend({
  components: { Users, InviteUserBtn },
  props: {
    accountId: {
      type: String,
      required: true,
    },
  },
  methods: {
    unshift(user) {
      (this.$refs.users as ListElement).unshift(user);
    },
  },
});
